module.exports = __webpack_public_path__ + "static/media/like-with-coin.fca154c9.svg";